import { c as _c } from "react/compiler-runtime";
export default function GridIcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M21 68h8v-8h-8v8zm2-6h4v4h-4v-4zm6-13h-8v8h8v-8zm-2 6h-4v-4h4v4zm47 12h10V57H74v10zm2-8h6v6h-6v-6zm14-39V10a1 1 0 0 0-1-1H51a1 1 0 0 0-1 1v26h2V21h36v63a1 1 0 0 1-1 1h-3V72H74v15h13a3 3 0 0 0 3-3V20zm-8 65h-6V74h6v11zM55 25v10h8V25h-8zm6 8h-4v-6h4v6zm23-8H66v10h18V25zm-10 8h-6v-6h6v6zm8 0h-6v-6h6v6zm-42 2v-8h-8v8h8zm-6-6h4v4h-4v-4zM21 75H10v14a3 3 0 0 1-3-3V12l35.76 13.66V36h2V25.66a2 2 0 0 0-1.29-1.87L19.15 14.5V8a1 1 0 0 0-2 0v5.78l-3.09-1.18a1 1 0 0 0 .07-.33V2a1 1 0 0 0-2 0v9.82l-4.42-1.69A2 2 0 0 0 5 12v74a5 5 0 0 0 5 5h20v-2h-9V75zm-2 14h-7V77h7v12zm-1-62h-8v8h8v-8zm-2 6h-4v-4h4v4zm13 5h-8v8h8v-8zm-2 6h-4v-4h4v4zm-9-6h-8v8h8v-8zm-2 6h-4v-4h4v4zm13-17h-8v8h8v-8zm-2 6h-4v-4h4v4zm57 8H74v10h10V41zm-2 8h-6v-6h6v6zm-64 0h-8v8h8v-8zm-2 6h-4v-4h4v4zm-6 13h8v-8h-8v8zm2-6h4v4h-4v-4zm59-24H33a1 1 0 0 0-1 1v52a5 5 0 0 0 5 5h30a5 5 0 0 0 5-5V39a1 1 0 0 0-1-1zm-6 56h-5v-9.21h5V94zm5-3a3 3 0 0 1-3 3V82.79h-9V94H37a3 3 0 0 1-3-3V51h36v40zM44.38 54H37v10h7.38V54zm-2 8H39v-6h3.38v6zm13.31-8h-7.38v10h7.37l.01-10zm-2 8h-3.38v-6h3.37l.01 6zM67 54h-7.38v10H67V54zm-2 8h-3.38v-6H65v6zm-20.62 6H37v10h7.38V68zm-2 8H39v-6h3.38v6zm13.31-8h-7.38v10h7.37l.01-10zm-2 8h-3.38v-6h3.37l.01 6zM67 68h-7.38v10H67V68zm-2 8h-3.38v-6H65v6z" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden={true} className={className} fill="currentColor" height="96" viewBox="0 0 96 96" width="96" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}